import { Link, useLocation } from 'react-router-dom';
import { Anchor, Github, Home } from 'lucide-react';
import { useStore } from '../hooks/useStore';

export default function Header() {
  const location = useLocation();
  const { session, resetEditor } = useStore();
  const isEditor = location.pathname.startsWith('/editor');

  return (
    <header className="h-12 sm:h-14 border-b border-dark-700 bg-dark-800 flex items-center justify-between px-2 sm:px-4">
      <div className="flex items-center gap-2 sm:gap-4 min-w-0">
        <Link
          to="/"
          className="flex items-center gap-1.5 sm:gap-2 text-dark-100 hover:text-white transition-colors flex-shrink-0"
          onClick={() => resetEditor()}
        >
          <Anchor className="w-5 h-5 sm:w-6 sm:h-6 text-accent-primary" />
          <span className="font-semibold text-base sm:text-lg hidden xs:inline">Helm Renderer</span>
        </Link>

        {isEditor && session && (
          <div className="flex items-center gap-1.5 sm:gap-2 ml-1 sm:ml-4 text-dark-400 min-w-0">
            <span className="hidden sm:inline">/</span>
            <span className="text-dark-200 text-sm sm:text-base truncate max-w-[100px] sm:max-w-[200px]">
              {session.chartName}
            </span>
            <span className="text-[10px] sm:text-xs bg-dark-700 px-1.5 sm:px-2 py-0.5 rounded flex-shrink-0">
              v{session.chartVersion}
            </span>
          </div>
        )}
      </div>

      <div className="flex items-center gap-1 sm:gap-2">
        {/* Home button - visible on mobile when in editor */}
        {isEditor && (
          <Link
            to="/"
            onClick={() => resetEditor()}
            className="btn btn-ghost btn-sm p-2 sm:hidden"
            title="Home"
          >
            <Home className="w-4 h-4" />
          </Link>
        )}

        <a
          href="https://github.com"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-ghost btn-sm p-2 sm:px-3 sm:py-1.5"
          title="GitHub"
        >
          <Github className="w-4 h-4" />
        </a>
      </div>
    </header>
  );
}
